import { PropTypes } from "prop-types";
import { QueryLoader } from "../../Loader";
import { StyledFilteredDecisionSliderHeader } from "../../../styles/StyledFilteredDecisionSlider/StyledFIlteredDecisionSlider";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useState } from "react";
import { Checkbox } from "../../Checkbox";
import { DecisionSlider } from "../DecisionSlider";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export function FilteredDecisionSlider({ name, requestFunc, options }) {
	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data } = useQuery(["decisionsList", options, requestFunc], () => requestFunc(axiosPrivate));
	const [filteredDecisions, setFilteredDecisions] = useState(false);
	const [checkboxState, setCheckboxState] = useState(false);

	useEffect(() => {
		if (isError) console.log(error);

		if (!isLoading) {
			if (checkboxState[0]) {
				setFilteredDecisions(data);
			} else {
				let filterId;
				Object.keys(checkboxState).map((e) => {
					if (checkboxState[e]) filterId = e;
				});

				let res;
				if (data?.length && data.length > 0) {
					res = data.filter((e) => e[name.toLowerCase()].id === parseInt(filterId));
				} else {
					res = [];
				}
				setFilteredDecisions(res);
			}
		}
	}, [data, isLoading, checkboxState]);

	useEffect(() => {
		const tempOptions = { ...options };
		const newOptions = { 0: true };

		Object.keys(tempOptions).map((e) => {
			newOptions[e] = false;
		});

		setCheckboxState(newOptions);
	}, [options]);

	const changeFilter = (id) => {
		const newOptions = { 0: false };

		Object.keys(options).map((e) => {
			newOptions[e] = false;
		});

		newOptions[id] = true;

		setCheckboxState(newOptions);
	};

	return (
		<>
			<StyledFilteredDecisionSliderHeader>
				<h4>{name}</h4>
				{checkboxState && (
					<div className="checkbox-container">
						<div className="checkboxFilter">
							<Checkbox name={"all"} value={checkboxState[0]} changeHandler={() => changeFilter(0)} />
							<span onClick={() => changeFilter(0)}>All</span>
						</div>
						{Object.keys(options).length > 1 &&
							Object.keys(options).map((e) => (
								<div className="checkboxFilter" key={e}>
									<Checkbox name={options[e]} value={checkboxState[e]} changeHandler={() => changeFilter(e)} />
									<span onClick={() => changeFilter(e)}>{options[e]}</span>
								</div>
							))}
					</div>
				)}
			</StyledFilteredDecisionSliderHeader>
			{isLoading || isError || !filteredDecisions ? (
				<QueryLoader />
			) : (
				<DecisionSlider clearSearchResults={false} data={filteredDecisions} />
			)}
		</>
	);
}

FilteredDecisionSlider.propTypes = {
	name: PropTypes.string,
	requestFunc: PropTypes.func,
	options: PropTypes.object,
};

export default FilteredDecisionSlider;
